<template>
  <div class="container">
    <br /><br />
    <card>
      <div class="card-body">
        <div v-if="sessid !== 'LOGOUT'">
          <div v-if="!failed">
            <h3>
              <i class="fa-solid fa-spinner"></i> Authentication in progress. Please wait...
            </h3>
          </div>
          <div v-if="failed">
            <h3>
              <i class="fa-solid fa-ban"></i> Invalid token.
            </h3>
          </div>
        </div>
        <div v-if="sessid === 'LOGOUT'">
          <h3>
            <i class="fa-solid fa-hourglass-end"></i> Session has expired
          </h3>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
  import { Auth } from "../project/Source/user";
  import { GenerateToken } from "../project/Source/crypto";
  import { AuthUser } from "../project/Source/localstate";
  import { login } from "../project/Source/helper";

  export default {
    props: {
      id: {
        type: String,
        default: "" // 'id' prop'u için default değer tanımlandı
      }
    },
    data() {
      return {
        failed: false,
        sessid: this.id,
      };
    },
    watch: {
      id() {
        this.sessid = this.id;
      }
    },
    mounted() {
      this.failed = false;
      this.$store.dispatch("logout");
      if (this.sessid && this.sessid !== "LOGOUT") {
        Auth(this.sessid).then((response) => {
          if (response.data) {
            AuthUser(response.data, GenerateToken(), GenerateToken());
            this.$router.push({ path: "/" });
          } else {
            this.failed = true;
          }
        });
      } else {
        // Eğer sessid "LOGOUT" ise, login sayfasına yönlendirme yapabilirsiniz
        this.failed = true;
        setTimeout(() => {
        window.location.replace(login);
      }, 2000);
      }
    }

  };
</script>
<style lang="scss" scoped>
</style>